import {NgModule, Optional, SkipSelf} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {TargetGroupModal} from "./slx-admin-user-details/modals/target-group-modal/target-group-modal.component";
import {NgSelectModule} from '@ng-select/ng-select';
import {SlxAdminUserDetailsComponent} from './slx-admin-user-details/slx-admin-user-details.component';
import {CustomerAdminUserDetailsComponent} from './customer-admin-user-details/customer-admin-user-details.component';
import {RouterModule} from "@angular/router";
import {SharedModule} from "app/shared/shared.module";
import {FlexLayoutModule} from "@angular/flex-layout";
import {RolesModalComponent} from './slx-admin-user-details/modals/roles-modal/roles-modal.component';
import {
  CustomerByCustomerNumberModal
} from "app/user/slx-admin-user-details/modals/customer-by-customer-number-modal/customer-by-customer-number-modal.component";
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {UnsavedChangesGuard} from "../shared/unsaved-changes.guard";
import {NgbTooltip} from "@ng-bootstrap/ng-bootstrap";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        TranslateModule,
        ReactiveFormsModule,
        FormsModule,
        NgSelectModule,
        FlexLayoutModule,
        TooltipModule.forRoot(),
        NgbTooltip
    ],
    declarations: [
        SlxAdminUserDetailsComponent,
        CustomerAdminUserDetailsComponent,
        TargetGroupModal,
        RolesModalComponent,
        CustomerByCustomerNumberModal
    ],
    exports: [
        SlxAdminUserDetailsComponent,
        CustomerAdminUserDetailsComponent,
        TargetGroupModal,
        RolesModalComponent,
        CustomerByCustomerNumberModal
    ],
    providers: [UnsavedChangesGuard]
})
export class UserModule {

  constructor(@Optional() @SkipSelf() parentModule: UserModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}
